import {
    useEffect,
    useState
} from 'react';

import {
    getAllAdminComments,
    deleteAdminComment
} from '../../../api/adminApi';

import './CommentManage.css';

const CommentManage = () => {

    // 검색어
    const [keyword, setKeyword] =
        useState('');





    // 현재 페이지
    const [currentPage, setCurrentPage] =
        useState(1);





    // 전체 페이지
    const [totalPages, setTotalPages] =
        useState(1);





    // 댓글 리스트
    const [comments, setComments] =
        useState<any[]>([]);





    // 댓글 조회
    useEffect(() => {

        fetchComments();

        // eslint-disable-next-line

    }, [keyword, currentPage]);





    // 댓글 가져오기
    const fetchComments = async () => {

        try {

            const response =
                await getAllAdminComments(

                    currentPage,

                    keyword
                );





            setComments(
                response.data.content
            );





            setTotalPages(
                response.data.totalPages
            );

        } catch (e) {

            console.error(e);
        }
    };





    // 댓글 삭제
    const handleDeleteComment = async (
        id: number
    ) => {

        try {

            if(
                !window.confirm(
                    '댓글을 삭제하시겠습니까?'
                )
            ) {

                return;
            }





            await deleteAdminComment(id);





            fetchComments();

        } catch (e) {

            console.error(e);
        }
    };





    // 페이지 그룹
    const pageGroup =
        Math.floor(
            (currentPage - 1) / 10
        );





    // 시작 페이지
    const startPage =
        pageGroup * 10 + 1;





    // 끝 페이지
    const endPage =
        Math.min(
            startPage + 9,
            totalPages
        );





    // 페이지 배열
    const pageNumbers =
        Array.from(

            {
                length:
                    endPage - startPage + 1
            },

            (_, i) =>
                startPage + i
        );





    return (

        <div className="comment-manage">

            {/* 검색 */}
            <div className="comment-search-wrap">

                <input

                    type="text"

                    placeholder="댓글 검색"

                    value={keyword}

                    onChange={(e) => {

                        setKeyword(
                            e.target.value
                        );





                        setCurrentPage(1);
                    }}

                    className="comment-search-input"
                />

            </div>





            {/* 헤더 */}
            <div className="comment-table-header">

                <div>번호</div>

                <div>댓글</div>

                <div>게시글</div>

                <div>작성자</div>

                <div>날짜</div>

                <div>관리</div>

            </div>





            {/* 댓글 리스트 */}
            <div className="comment-table">

                {

                    comments.map((comment) => (

                        <div

                            className="comment-row"

                            key={comment.id}
                        >

                            {/* 번호 */}
                            <div className="comment-id">

                                {comment.id}

                            </div>





                            {/* 댓글 */}
                            <div className="comment-content">

                                {comment.content}

                            </div>





                            {/* 게시글 */}
                            <div className="comment-post">

                                {comment.postContent}

                            </div>





                            {/* 작성자 */}
                            <div className="comment-writer">

                                {comment.nickname}

                            </div>





                            {/* 날짜 */}
                            <div className="comment-date">

                                {

                                    new Date(

                                        comment.createdAt

                                    ).toLocaleString(
                                        'sv-SE'
                                    )
                                }

                            </div>





                            {/* 삭제 */}
                            <div className="comment-action">

                                <button

                                    className="comment-delete-button"

                                    onClick={() =>

                                        handleDeleteComment(
                                            comment.id
                                        )
                                    }
                                >

                                    삭제

                                </button>

                            </div>

                        </div>
                    ))
                }

            </div>





            {/* 페이지네이션 */}
            <div className="pagination-wrap">

                {/* 처음 */}
                <button

                    className="page-button"

                    onClick={() =>

                        setCurrentPage(1)
                    }
                >

                    {'<<'}

                </button>





                {/* 이전 */}
                <button

                    className="page-button"

                    onClick={() => {

                        if(currentPage > 1) {

                            setCurrentPage(
                                currentPage - 1
                            );
                        }
                    }}
                >

                    {'<'}

                </button>





                {/* 번호 */}
                {

                    pageNumbers.map((page) => (

                        <button

                            key={page}

                            className={

                                currentPage === page

                                    ? 'page-button active'

                                    : 'page-button'
                            }

                            onClick={() =>

                                setCurrentPage(page)
                            }
                        >

                            {page}

                        </button>
                    ))
                }





                {/* 다음 */}
                <button

                    className="page-button"

                    onClick={() => {

                        if(currentPage < totalPages) {

                            setCurrentPage(
                                currentPage + 1
                            );
                        }
                    }}
                >

                    {'>'}

                </button>





                {/* 마지막 */}
                <button

                    className="page-button"

                    onClick={() =>

                        setCurrentPage(
                            totalPages
                        )
                    }
                >

                    {'>>'}

                </button>

            </div>

        </div>
    );
};

export default CommentManage;